import styled from 'styled-components/macro';
import { colorCoreBlack900Base, colorCoreGray500 } from '@yme/tokens/colors';
import { getTextStyles } from '@yme/utils/styles';
export const SeparatorTextStyled = styled.div `
  display: flex;
  flex-direction: row;
  &:after,
  &:before {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid ${colorCoreGray500};
    margin: auto;
  }
  &:after {
    margin-left: 24px;
  }
  &:before {
    margin-right: 24px;
  }
`;
export const SeparatorStyled = styled.div `
  text-transform: uppercase;
  text-align: center;
  color: ${colorCoreBlack900Base};
  ${getTextStyles('Ubuntu', 500, 14, 20)};
  margin: 40px 0;
  position: relative;
`;
